import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "done",
  "use": "done-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"done\"><path d=\"M13.6 22.453L8.213 17.12l1.173-1.173 4.213 4.267 9.013-9.067 1.173 1.173z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol